import React from 'react';

import componentLoader from '../../componentLoader';

export const InterFromMobile = React.lazy(() =>
  componentLoader(() => import('./InterFromMobile'))
);
export const Devis = React.lazy(() =>
  componentLoader(() => import('./Devis'))
);
export const PropositionArtisan = React.lazy(() =>
  componentLoader(() => import('./PropositionArtisan'))
);
export const Propositions = React.lazy(() =>
  componentLoader(() => import('./Propositions'))
);
export const PropositionsDetail = React.lazy(() =>
  componentLoader(() => import('./PropositionsDetail'))
);
export const ArtisanHolidays = React.lazy(() =>
  componentLoader(() => import('./ArtisanHolidays'))
);
export const ArtisanUpload = React.lazy(() =>
  componentLoader(() => import('./ArtisanUpload'))
);
export const SignPages = React.lazy(() =>
  componentLoader(() => import('../../components/SignPages'))
);

export const Faq = React.lazy(() => componentLoader(() => import('./Faq')));

export const SousMetiers = React.lazy(() =>
  componentLoader(() => import('./SousMetiers'))
);

export const Profile = React.lazy(() =>
  componentLoader(() => import('./Profile'))
);

export const Paiements = React.lazy(() =>
  componentLoader(() => import('./Paiements'))
);

export const GrilleTarifaire = React.lazy(() =>
  componentLoader(() => import('./GrilleTarifaire'))
);

export const MesDevis = React.lazy(() =>
  componentLoader(() => import('./MesDevis'))
);

export const InstallApp = React.lazy(() =>
  componentLoader(() => import('./InstallApp'))
);
